import { combineReducers } from 'redux'
import DefaultReducers from 'reducers'
import algolia from 'reducers/algolia'
import algoliaReducer from 'reducers/algolia2/data'
export default combineReducers({ ...DefaultReducers, ...algolia, algolia: algoliaReducer })